@if (showPayment()) {
  <payment-summary
    [showpaymentsummary]="showPayment()"
    [invoiceDetailById]="getInvoiceById$()"
    (closeSidePopup)="ClosePaymentSummary($event)"
  />
}

@if (showPaymentStatusTimeLine) {
  <payment-status-timeline
    [visible]="showPaymentStatusTimeLine"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [uuid]="uuid"
    [isPayment]="ispayment"
    (GoToClientSubscription)="GoToClientDetails($event)"
  />
}
